import { NS_SUPPORT_EMAILS, NS_SUPPORT_EMAILS_TOKEN } from '@customer-portal/utils';

export function provideCustomerSupport() {
  return [
    {
      provide: NS_SUPPORT_EMAILS_TOKEN,
      useValue: NS_SUPPORT_EMAILS,
    },
  ];
}
